import React, {Component} from "react";
import Authentication from "../../authentication/Authentication";
import "./Tags.css"

export default class Tags extends Component {

    constructor(props) {
        super(props);
        this.state = {
            temporaryTags: this.props.tags,
            tagsToAddOnSave: [],
            tagsToDeleteOnSave: [],
            currentKeyValue: "",
            currentValueValue: "",
            showEditTagValue: false,
            currentEditValue: ""
        };

        this.authentication = new Authentication();
    };

    handleKeyChange = (e) => {
        this.setState({
            currentKeyValue: e.target.value,
        })
    }

    handleValueChange = (e) => {
        this.setState({
            currentValueValue: e.target.value,
        })
    }

    handleEditValueChange = (e) => {
        this.setState({
            currentEditValue: e.target.value
        })
    }

    handleAdd = (currentTags, key, value, newTags) => {
        const newState = [...currentTags]
        const tagToAdd = {
            "tag_key": key,
            "tag_value": value
        }
        const tagsToSave = {...newTags}
        newState.push(tagToAdd)
        tagsToSave[key] = value
        this.setState({
            temporaryTags: newState,
            currentKeyValue: "",
            currentValueValue: "",
            tagsToAddOnSave: tagsToSave
        })
    }

    handleReset = (originalTags) => {
        this.setState({
            temporaryTags: originalTags,
            currentKeyValue: "",
            currentValueValue: ""
        })
    }

    handleDelete = (currentList, tagKey, tagValue, tagsToDelete) => {
        const newState = [...currentList]
        const tagsToDeleteOnSave = {...tagsToDelete}
        tagsToDeleteOnSave[tagKey] = tagValue
        this.setState({
            temporaryTags: newState.filter(tag => {
                return tag.tag_key !== tagKey
            }),
            tagsToDeleteOnSave: tagsToDeleteOnSave
        })
    }

    handleEditSubmit = (currentTags, editKey, editValue, tagsToAddOnSave, index) => {
        const newState = [...currentTags]
        const newUpdatedState = newState.map(tag => {
            if (tag.tag_key === editKey) {
                const newPair = {
                    "tag_key": editKey,
                    "tag_value": editValue
                }
                return newPair;
            }
            return tag;
        })
        const tagsToSave = {...tagsToAddOnSave}
        tagsToSave[editKey] = editValue
        this.setState({
            temporaryTags: newUpdatedState,
            tagsToAddOnSave: tagsToSave
        })

        this.toggleShowEditTagValue(index)
    }

    toggleShowEditTagValue = (index) => {
        if (index === this.state.editValueIndex) {
            this.setState({
                showEditTagValue: !this.state.showEditTagValue,
                editValueIndex: index
            })
        } else {
            this.setState({
                showEditTagValue: true,
                editValueIndex: index
            })
        }

    }

    render() {
        return (
            <>
                <h2 className={"config-header"} data-testid="config.header.tags">Tags</h2>
                <ul>
                    <li>Click edit to add or change your tags</li>
                    <li>Enter key value pairs into the input boxes</li>
                    <li>Click to plus button to add the tag then save</li>
                </ul>

                <div className={"whitelist-header"}>
                    <p className={"field-name"} data-testid="config.tags">Tags: </p>
                    <div className={"whitelist-buttons"} data-testid="config.tags.buttons">
                        {this.props.showEditTags ? <>
                                <div data-testid="config.tags.button.save" onClick={() => this.props.handleTagSubmit(this.state.tagsToAddOnSave, this.state.tagsToDeleteOnSave)}>
                                    <i className="fa fa-save whitelist-icon"/>
                                    <p>Save</p>
                                </div>
                                <div data-testid="config.tags.button.reset" onClick={() => this.handleReset(this.props.tags)}>
                                    <i className="fa fa-undo whitelist-icon"/>
                                    <p>Reset</p>
                                </div>
                                <div data-testid="config.tags.button.close" onClick={() => this.props.toggleEditTags()}>
                                    <i className="fa fa-close whitelist-icon"/>
                                    <p>Close</p>
                                </div>
                            </> :
                            <>
                                <div>
                                    <i data-testid="config.tags.button.refresh" className="fa fa-refresh whitelist-icon"/>
                                    <p>Refresh</p>
                                </div>
                                <div data-testid="config.tags.button.edit" onClick={() => this.props.toggleEditTags()}>
                                    <i className="fa fa-edit whitelist-icon"/>
                                    <p>Edit</p>
                                </div>
                            </>
                        }
                    </div>
                </div>
                {this.props.requesting ?
                    <div className={"loading-container"} data-testid="config.tags.loading.container">
                        Requesting...
                        <i className="fa fa-spinner fa-pulse fa-3x fa-fw edit-loading"/>
                    </div>
                    :
                    this.props.showEditTags ?
                        <>
                            <div>
                                <ul>
                                    {this.state.temporaryTags.map((tag, index) => {
                                        return (
                                            <div className={"tag-list-item-edit"} data-testid="config.tags.editTag" key={index}>
                                                <li>{tag.tag_key}: {tag.tag_value} </li>
                                                <i data-testid="config.tags.editTag.button.delete" onClick={() => this.handleDelete(this.state.temporaryTags, tag.tag_key, tag.tag_value, this.state.tagsToDeleteOnSave)} className="fa fa-trash add-delete-icon"/>
                                                <i data-testid="config.tags.editTag.button.edit" onClick={() => this.toggleShowEditTagValue(index)} className="fa fa-edit add-delete-icon"/>
                                                {this.state.showEditTagValue && index === this.state.editValueIndex ?
                                                    <div className={"edit-tag-input"}  data-testid="config.tags.editTag.input">
                                                        <input data-testid="config.tags.editTag.input.tagValue" value={this.state.currentEditValue} onChange={(e) => this.handleEditValueChange(e)} placeholder={"New tag value"}/>
                                                        <button data-testid="config.tags.editTag.button.enter" onClick={() => this.handleEditSubmit(this.state.temporaryTags, tag.tag_key, this.state.currentEditValue, this.state.tagsToAddOnSave, index)}>Enter</button>
                                                    </div>
                                                    :
                                                    <></>}
                                            </div>

                                        )
                                    })}
                                </ul>
                            </div>
                            <div>
                                <p>Add Tags:</p>
                                <div className={"add-tags-section"} data-testid="config.tags.add">
                                    <input data-testid="config.tags.input.key" value={this.state.currentKeyValue} placeholder={"Key"} onChange={(e) => this.handleKeyChange(e)}/>
                                    <input data-testid="config.tags.input.value" value={this.state.currentValueValue} placeholder={"Value"} onChange={(e) => this.handleValueChange(e)}/>
                                    <i data-testid="config.tags.button.add" onClick={() => this.handleAdd(this.state.temporaryTags, this.state.currentKeyValue, this.state.currentValueValue, this.state.tagsToAddOnSave)} className="fa fa-plus add-delete-icon"/>
                                </div>
                            </div>
                        </>
                        :
                        <div>
                            <ul>
                                {this.props.tags.map((tag, index) => {
                                    return (
                                        <div className={"tag-list-item"} data-testid="config.tags.list.item" key={index}>
                                            <li>{tag.tag_key}: {tag.tag_value}</li>
                                        </div>

                                    )
                                })}
                            </ul>
                        </div>
                }
            </>
        )
    }
}



